import { objectType } from "_src/constants";
import output from "_src/engine/output";
import zstdEncoder from "_src/engine/loaders/zstd/zstd_encoder";
import plnEncoder from "_src/engine/loaders/pln/pln_encoder";
import reformer from "_src/reformer/reformer";
import config from "_src/config";

export default {

  ENCODER_PLN: 0,
  ENCODER_ZSTD: 1,

  zstdCompressionLevel: 5,

  getPackedBuffers(chunk, encoderType) {

    const geometry = chunk.geometry;

    if (geometry.empty()) {
      output.error(output.DEVELOPERS_ERROR, "Trying to save empty chunk");
      return Promise.resolve(null);
    }

    switch (encoderType) {
    case this.ENCODER_PLN:
      return plnEncoder.encodeMain(geometry);
    case this.ENCODER_ZSTD:
      if (config.useWorkers) {
        return zstdEncoder.encodeWorker(geometry, this.zstdCompressionLevel);
      } else {
        return zstdEncoder.encodeMain(geometry, this.zstdCompressionLevel);
      }
    default:
      output.error(output.API_ERROR, "Can't pack the geometry. Wrong encoder type:" + encoderType);
      return Promise.resolve(null);
    }

  },

  serializeObject(property, objectJSON, type) {
    switch (type) {
      case objectType.FUSION:
      case objectType.SURFELS:
      case objectType.SCAN:
      case objectType.CAD:
        reformer.serializeObject(property, objectJSON);
        break;
      case objectType.GROUP:
        reformer.serializeGroup(property, objectJSON);
        break;
    }
  }
}
